import React from "react";
import { ColumnType } from "antd/lib/table";
import { BundleProduct } from "@/Contracts/Products";
import { currencyInputProps } from "@/Utils/Currency";
import { BundledProductRowFormNameLabel } from "../../DocumentsPage/Drawers/DocumentProductDrawers/DocumentProductDrawersComponents/BundledProductRowFormNameLabel/BundledProductRowFormNameLabel";
import { PricingNameInput } from "../../DocumentsPage/Drawers/DocumentProductDrawers/DocumentProductDrawersComponents/BundleProductDrawerTable/BundleProductDrawerTable";
import PopInput from "@molecules/ZPopInput";
import { BundledProductRowFormOptions } from "../../DocumentsPage/Drawers/DocumentProductDrawers/DocumentProductDrawersComponents/BundledProductRowFormOptions";

interface BundledProductTableColumnsProps {
	handlePricingChange: (itemId: string) => (newPricingId: string) => void;
	handleBundledProductSetupPriceChange: (
		itemId: string
	) => (value?: number | string | null) => void;
	handleBundledProductCostPriceChange: (
		itemId: string
	) => (value?: number | string | null) => void;
	handleBundledProductSellPriceChange: (
		itemId: string
	) => (value?: number | string | null) => void;
	handleBundledProductQuantityChange: (
		itemId: string
	) => (value?: number | string | null) => void;
	handleBundleProductChildDelete: (itemId: string) => () => void;
	handleEditDrawerOpen: (product: BundleProduct) => () => void;
	toggleBundleProductOptional: (product: BundleProduct) => () => void;
	isReadonly: boolean;
}
export const getBundledProductTableColumns = (
	props: BundledProductTableColumnsProps
): ColumnType<BundleProduct>[] => [
	{
		title: "Product name",
		dataIndex: "name",
		key: "name",
		width: 300,
		render: (_text: unknown, product: BundleProduct) => {
			const { selected_setup_price, item, selected_pricing_id, item_id } =
				product;
			return (
				<BundledProductRowFormNameLabel
					product={{ ...product, name: product.name || item.name }}
				>
					<PricingNameInput
						pricingArray={item.pricing}
						selectedPricingId={selected_pricing_id}
						onChange={props.handlePricingChange(item_id)}
					/>
					<div className="product-name-container">
						<label className="setup-price-wrap">
							<span>Setup Fee:</span>
							<PopInput
								disabled={props.isReadonly}
								value={selected_setup_price || 0}
								min={0}
								onChange={props.handleBundledProductSetupPriceChange(
									item_id
								)}
								inputAlign="left"
								{...currencyInputProps}
								decimal
							/>
						</label>
					</div>
				</BundledProductRowFormNameLabel>
			);
		}
	},
	{
		title: "Cost Price",
		dataIndex: "selected_cost_price",
		key: "selected_cost_price",
		render: (selected_cost_price: number, product: BundleProduct) => (
			<div className="table-input-wrap">
				<PopInput
					disabled={props.isReadonly}
					value={selected_cost_price}
					min={0}
					onChange={props.handleBundledProductCostPriceChange(
						product.item_id
					)}
					{...currencyInputProps}
					decimal
				/>
			</div>
		)
	},
	{
		title: "Selling Price",
		dataIndex: "sell_price",
		key: "sell_price",
		render: (sell_price: number, product: BundleProduct) => (
			<div className="table-input-wrap">
				<PopInput
					disabled={props.isReadonly}
					value={sell_price}
					min={0}
					{...currencyInputProps}
					onChange={props.handleBundledProductSellPriceChange(
						product.item_id
					)}
					decimal
				/>
			</div>
		)
	},
	{
		title: "Quantity",
		dataIndex: "quantity",
		key: "quantity",
		render: (quantity: number, product: BundleProduct) => (
			<div className="table-input-wrap">
				<PopInput
					disabled={props.isReadonly}
					value={quantity}
					min={1}
					onChange={props.handleBundledProductQuantityChange(
						product.item_id
					)}
				/>
			</div>
		)
	},
	{
		title: "",
		dataIndex: "name",
		key: "options",
		render: (_name: string, product: BundleProduct) => (
			<div className="table-more-option-wrap">
				<BundledProductRowFormOptions
					isReadonly={props.isReadonly}
					deleteBundleProductChild={props.handleBundleProductChildDelete(
						product.item_id
					)}
					onEditDrawerOpen={props.handleEditDrawerOpen({
						...product,
						name: product.name || product.item.name
					})}
					toggleBundleProductOptional={props.toggleBundleProductOptional(
						product
					)}
					isOptional={product.is_optional ?? false}
				/>
			</div>
		)
	}
];
